/**
 * Given a preferred number, a minimum number and maximum number:
 * returns min if preferred is less than min.
 * returns max if preferred is greater than max.
 * returns preferred if preferred is greater than min and less than max.
 * @param {*} n Preferred value
 * @param {*} min Minimum value
 * @param {*} max Maximum value
 * @returns {Number} evaluated value
 */
export function clamp(n, min, max) {
  if (n < min) {
    return min;
  }

  if (n > max) {
    return max;
  }

  return n;
}

/**
 * Removes null-valued keys from an object.
 * @param {Object} obj The object from which to remove null-valued keys.
 * @returns {Object} A copy of obj with keys containing null values removed.
 */
export function compact(obj) {
  return Object.entries(obj).reduce(
    (a, [k, v]) => (v === null ? a : ((a[k] = v), a)),
    {}
  );
}
